module.exports = __webpack_public_path__ + "assets/img/pay-cg.1e2b9c36.png";